export default {
  musicalQuote: {
    id: 'home_musical_quote',
    defaultMessage: '“Forever young, I wanna be forever youuuuuuuuung, etc.“',
  },
  musicalQuoteAuthor: {
    id: 'home_musical_quote_author',
    defaultMessage: 'Alphaville, 1984',
  },
}
